import { render, staticRenderFns } from "./Zjhx.vue?vue&type=template&id=fa135c16&scoped=true&"
import script from "./Zjhx.vue?vue&type=script&lang=js&"
export * from "./Zjhx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa135c16",
  null
  
)

export default component.exports